/**
 * Runs an async task without blocking the caller. Rejections are caught and logged
 * so background refreshes (e.g. unread counts) do not surface as unhandled promise rejections.
 * AbortErrors are expected (the request was cancelled via `cancelGroup` on navigation/re-render)
 * and are ignored rather than logged as failures.
 */
export const runFireAndForget = (task: () => Promise<void>, context = 'Async task'): void => {
    void task().catch((err: unknown) => {
        if ((err as { name?: unknown } | null)?.name === 'AbortError') {
            return;
        }
        const message = err instanceof Error ? err.message : String(err);
        console.error(`${context} failed:`, message, err);
    });
};
